
@switch (question.dataType) {
  @case ('STRING') {
    <!-- TEXT -->
    <odq-dynamic-text [question]="question"
      [control]="control"
    [summary]="summary"></odq-dynamic-text>
  }
  @case ('DATE') {
    <!-- DATE -->
    <odq-dynamic-date [question]="question"
      [control]="control"
    [summary]="summary"></odq-dynamic-date>
  }
  @case ('NUMBER') {
    <!-- NUMBER -->
    <odq-dynamic-number [question]="question"
      [control]="control"
    [summary]="summary"></odq-dynamic-number>
  }
  @case ('YESNO') {
    <!-- YES/NO -->
    <odq-dynamic-yes-no [question]="question"
      [control]="control"
    [summary]="summary"></odq-dynamic-yes-no>
  }
  @default {
    <!-- OTHER -->
    <odq-dynamic-text [question]="question"
      [control]="control"
    [summary]="summary"></odq-dynamic-text>
  }
}
